// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Divider,
    Fab,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang } from '../../../../api/helper';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [valGudangTujuan, setValGudangTujuan] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        mmgudang_asal_id: any,
        mmgudang_tujuan_id: any,
        keterangan: any,
        pic: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.transferStok, cabang, token);
            if(response.length > 0 && response.length === 1){
                setValDoctag(response[0].nama)
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchGudang = async () => {
            const response = await getGudang(token);
            setListGudang(response);
        };
        fetchDoctag();
        fetchGudang();
    }, [])
    
    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue.nama )
    }
    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_asal_id', newValue ? newValue.id : null)
        setValGudang(newValue);
    }
    const handleChangeAutocompleteGudangTujuan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_tujuan_id', newValue ? newValue.id : null)
        setValGudangTujuan(newValue);
    }
    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/transfer-stok/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/mm/transfer-stok/detail/' + response.data.data)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Transfer Stok
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Asal'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudangTujuan}
                                        options={listGudang}
                                        id='gudang_tujuan'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ✅ tampilkan nama
                                        onChange={handleChangeAutocompleteGudangTujuan}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang Tujuan'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
